var $ = jQuery;

$(document).ready(function () {
  $("#stamped-main-widget .stamped-starratings").attr("role", "img");

  $("a.stamped-reviews-link")
    .filter(function () {
      return $(this).is(":empty");
    })
    .css("display", "none");
  $("input#Search").removeAttr("aria-owns");
  $("#product_specs").attr("role", "presentation");
  $(".collection-image.collection-image--is-collection img").attr("alt", "");
  console.log("ready!");
});

$(window).on("load", function () {
  setTimeout(function () {
    $("a.stamped-reviews-link")
      .filter(function () {
        return $(this).is(":empty");
      })
      .attr("aria-label", "Review title not available");

    $("a.stamped-reviews-link")
      .filter(function () {
        return $(this).is(":empty");
      })
      .css("display", "none");
  }, 2000);
  $('.menu-popup__warning [data-ref="cancel"]').attr("aria-label", "Cancel");
  $('.menu-popup__warning [data-ref="accept"]').attr("aria-label", "Accept");
  $(".stamped-pagination.stamped-reviews-ul").removeAttr("role");
  $("h3:empty").remove();
  console.log("Load");
});
